<template>
    <accordion-item>
        <h2 slot="header">
            Dependency on Income &mdash; {{currencyFormat(value)}}
        </h2>
        <p>
            This head of loss is determined from the deceased's date of death to the deceased's 'but for' date of
            death.
        </p>
        <p>
            For earnings, the multiplicand is assessed using (i) your selected annual gross income for the deceased
            (converted to Net equivalent by the tool), (ii) assumes the dependent has no income, and (iii) applies
            the standard dependency formula for assessing the multiplicand dependent on the number of dependents.
        </p>
        <p>
            Retirement is assumed at age 65. Thereafter a pension dependency multiplicand of £10,000 is applied.
            This is broadly assessed using data within the UK Government Statistics on Pensions &mdash; 
            <a href="https://www.gov.uk/government/statistics/pensioners-incomes-series-financial-year-201516"
               target="_blank">
                https://www.gov.uk/government/statistics/pensioners-incomes-series-financial-year-201516
            </a>
        </p>
        <p>
            The period between death and assumed date of trial/settlement is 
            discounted by Table E Factor. The multiplier is applied from date of
            trial/assumed settlement but discounted by Table F Factor.
        </p>
    </accordion-item>
</template>

<script>
    import AccordionItem from "components/accordion/AccordionItem";
    import currencyFormat from 'mixins/currencyFormat';

    export default {
        name: "dependency-income-modal",
        components: {
            AccordionItem
        },
        mixins:[
            currencyFormat
        ],
        props: {
            value: {
                required: true
            }
        }
    }
</script>


// WEBPACK FOOTER //
// DependencyIncomeModal.vue?72a50837